import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import Address from "./Address";

class VehicleNonDppaRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      results.push(
        <Table.Row key={`VehNonDppa_Record_Name_Row_${this.props.index}`}>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>
            {getPersonName(
              _.get(node, "first[0]._", ""),
              "",
              _.get(node, "last[0]._", ""),
              this.props
            )}
          </Table.Cell>
          <Table.Cell>Year/Make/Model:</Table.Cell>
          <Table.Cell>
            {`${_.get(node, "year[0]._", "")} ${_.get(
              node,
              "make[0]._",
              ""
            )} ${_.get(node, "model[0]._", "")}`}
          </Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`VehNonDppa_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell>
            <Address addressNode={node} {...this.props} />
          </Table.Cell>
          <Table.Cell>VIN:</Table.Cell>
          <Table.Cell>{_.get(node, "vin[0]._", "")}</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default VehicleNonDppaRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/VehicleNonDppaRecordDetail.js